<template>
  <div>
    <filtro-documento
      :filtro-inicial="mostrarSelecionados ? 3 : 0"
      @filtrado="filtraDadosTabela($event)"
    />
    <vue-good-table
      ref="documentosTabela"
      :columns="colunas"
      :rows="valueAttr"
      row-style-class="clickable"
      :search-options="{
        enabled: true,
        externalQuery: busca
      }"
      :select-options="{
        enabled: true,
        selectionInfoClass: 'custom-class',
        selectionText: 'rows selected',
        clearSelectionText: 'clear',
        disableSelectInfo: true, // disable the select info panel on top
        selectAllByGroup: true,
        selectOnCheckboxOnly: true
      }"
      theme="view"
      @on-row-click="selecionaLinha"
      @on-select-all="selecionaTodos"
    >
      <!-- no records -->
      <div slot="emptystate">
        <p style="text-align:center; margin:0">
          Nenhum registro foi encontrado.
        </p>
      </div>
      <template
        slot="table-row"
        slot-scope="props"
      >
        <span v-if="props.column.useSlot">
          <slot
            name="customizado"
            :customizado="props"
          />
        </span>
        <span v-else-if="props.column.field == 'descricao'">
          {{ props.row.descricao }}
          <span :class="['documento-badge', {'badge badge-success':props.row.ativo, 'badge badge-danger': !props.row.ativo}]">
            {{ props.row.ativo ? 'Ativo' : 'Inativo' }}
          </span>
          <span
            v-if="props.row.customizado"
            class="documento-badge badge badge-primary"
          >
            {{ 'Customizado' }}
          </span>
          <span
            v-if="props.row.naoRecorrente"
            class="documento-badge badge badge-primary"
          >
            {{ 'Não recorrente' }}
          </span>
          <span
            v-if="props.row.multiplaCobranca"
            class="documento-badge badge badge-info"
          >
            {{ 'Cobrança múltipla' }}
          </span>
        </span>
        <span v-else>
          {{ props.formattedRow[props.column.field] }}
        </span>
      </template>
    </vue-good-table>
  </div>
</template>

<style lang="scss">
@import "@core/scss/vue/libs/vue-good-table.scss";

.view {
  .vgt-inner-wrap {
    box-shadow: none !important;
  }
}

.main-menu.menu-dark .navigation > li ul li > a {
  padding: 8px 10px 8px 12px;
}

.documento-close {
  padding: 0 0.62rem 0.2rem 0.62rem !important;
  margin: -0.1rem -0.5rem -0.8rem auto !important;
}

.documento-badge {
  height: 1.2rem;
  font-size: 10px;
  font-weight: 600;
  border-radius: 2px;
  margin-left: 0.5rem;
}
</style>

<script>
import { VueGoodTable } from 'vue-good-table'
import { mapActions } from 'vuex'

export default {
  name: 'TabelaDocumento',
  components: {
    VueGoodTable,
    FiltroDocumento: () => import('@/shared/components/visualizacao-documento/shared/components/filtro-documento/FiltroDocumento.vue'),
  },
  props: {
    colunas: {
      type: Array,
      required: true,
    },
    mostrarSelecionados: {
      type: Boolean,
      default: false,
    },
    value: {
      type: Array,
      default: () => null,
    },
    isEmpresaDocs: {
      type: Boolean,
      default: false,
    },
    filtrarDocs: {
      type: Boolean,
      default: false,
    },
    filtrarPosSelecao: {
      type: Boolean,
      default: true,
    },
  },
  data() {
    return {
      value_: [],
      docsBackupFiltro: null,
      busca: '',
      selecionados: [],
      filtro: {
        busca: '',
        filtroAtual: 0,
      },
    }
  },
  computed: {
    valueAttr: {
      set(value) {
        // eslint-disable-next-line no-underscore-dangle
        this.value_ = value
      },
      get() {
        // eslint-disable-next-line no-underscore-dangle
        return this.value_
      },
    },
    hasFiltro() {
      return (this.docsBackupFiltro && this.docsBackupFiltro.length > 0)
    },
  },
  watch: {
    // value(val) {
    //   if (!this.hasFiltro || (this.hasFiltro && !this.isArrayIgual(val, this.docsBackupFiltro))) {
    //     this.valueAttr = val
    //   }
    // },
    filtrarDocs(value, oldValue) {
      if (value && value !== oldValue) {
        this.docsBackupFiltro = [...this.valueAttr]
        this.filtraDadosTabela(this.filtro)
        this.$emit('filtrado')
      }
    },
  },
  created() {
    this.valueAttr = this.value
    if (this.mostrarSelecionados) {
      this.filtraDadosTabela({ filtroAtual: 3 })
    }
  },
  methods: {
    ...mapActions('empresa', ['setFiltrarDocsModelo', 'setFiltrarDocsContato']),
    getCode() {
      return Date.now().toString(36) + Math.random().toString(36).substring(2)
    },
    selecionar() {
      this.dadosTabela.forEach(each => {
        this.$set(each, 'vgtSelected', each.selecionado)
        this.$set(each, 'code', this.getCode())
      })
    },
    selecionaLinha(params) {
      if (this.atualizarEmpresas) {
        this.$bvModal.show(`tabelaDocumento${params.row.id}`)
      }

      // parte dessas condições serve para obter os documentos quando está na tela de empresa (mover para empresa quando tiver tempo )
      const doc = this.valueAttr.find(f => (params.row.id && f.id === params.row.id)
        || (params.row.code && f.code === params.row.code)
        || (!params.row.id && !params.row.code && !f.customizado && f.documentoId && f.documentoId === params.row.documentoId)
        || (!params.row.id && !params.row.code && f.customizado && f.empresaDocumentoId && f.empresaDocumentoId === params.row.empresaDocumentoId))

      this.$set(doc, 'selecionado', params.selected)
      this.$set(doc, 'vgtSelected', params.selected)
      if (!doc.code) {
        this.$set(doc, 'code', this.getCode())
      }

      this.$emit('documento-selecionado', { documento: doc, selecionado: params.selected })
      if (this.filtrarPosSelecao) {
        this.$nextTick(() => {
          if (this.hasFiltro) {
            this.docsBackupFiltro = null
            this.filtraDadosTabela(this.filtro)
          }
        })
      }
    },
    selecionaTodos(params) {
      params.selectedRows.forEach(row => {
        if (this.atualizarEmpresas) {
          this.$bvModal.show(`escolhaEmpresa${row.id}`)
        }
        this.$set(row, 'selecionado', true)
        this.$set(row, 'vgtSelected', true)
        if (!row.code) {
          this.$set(row, 'code', this.getCode())
        }
      })

      this.valueAttr.forEach(doc => {
        this.$set(doc, 'selecionado', params.selected)
        this.$set(doc, 'vgtSelected', params.selected)
        if (!doc.code) {
          this.$set(doc, 'code', this.getCode())
        }
      })

      this.$emit('documento-selecionado', { selecionado: params.selected })
      if (this.filtrarPosSelecao) {
        this.$nextTick(() => {
          if (this.hasFiltro) {
            this.docsBackupFiltro = null
            this.filtraDadosTabela(this.filtro)
          }
        })
      }
    },
    //
    // Métodos para manipulação de dados
    //
    $refresh(documentos) {
      /* ATENÇÃO:
      *  É feito dessa forma, porque quando um documento customizado é descelecionado
      *  o documento é removido, alterando assim a quantidade de linhas, mas a grid mantém a seleção de antes de remover o item
      */
      this.valueAttr = []
      this.$nextTick(() => {
        this.valueAttr = documentos
        this.$nextTick(() => {
          if (this.hasFiltro) {
            this.docsBackupFiltro = null
            this.filtraDadosTabela(this.filtro)
          }
        })
      })
    },
    //
    /// Métodos relacionados ao filtro dos documentos
    //
    iniciarFiltro() {
      if (this.docsBackupFiltro && this.docsBackupFiltro.length > 0) {
        this.encerrarFiltro()
      }
      this.docsBackupFiltro = [...this.valueAttr]
    },
    encerrarFiltro() {
      this.valueAttr = [...this.docsBackupFiltro]
      this.docsBackupFiltro = null
    },
    filtraDadosTabela(filtro) {
      if (filtro.busca && filtro.busca !== '') {
        if (this.docsBackupFiltro === null) {
          this.docsBackupFiltro = [...this.valueAttr]
        }
        this.filtro.busca = filtro.busca
        this.valueAttr = this.getPorBusca(filtro.busca)
      } else {
        if (this.filtro.busca !== '') {
          this.valueAttr = [...this.docsBackupFiltro]
          this.docsBackupFiltro = null
          this.filtro.busca = ''
        }

        this.iniciarFiltro()
        this.filtro.filtroAtual = filtro.filtroAtual

        if (filtro.filtroAtual > 0 && filtro.filtroAtual < 5) {
          if ([1, 2].includes(filtro.filtroAtual)) {
            this.valueAttr = this.getPorAtivo(filtro.filtroAtual === 1)
          } else {
            this.valueAttr = this.getPorSelecionado(filtro.filtroAtual === 3)
          }
        } else if (filtro.filtroAtual >= 5) {
          this.valueAttr = this.getPor([5, 6].includes(filtro.filtroAtual), [5, 7].includes(filtro.filtroAtual))
        }
      }
    },
    getPor(ativo, selecionado) {
      // eslint-disable-next-line eqeqeq
      return this.valueAttr.filter(f => f.ativo == ativo
        && ((!selecionado && !f.vgtSelected)
          || (f.vgtSelected === selecionado)))
    },
    getPorAtivo(ativo) {
      return this.valueAttr.filter(f => f.ativo === ativo)
    },
    getPorSelecionado(selecionado) {
      return this.valueAttr.filter(f => {
        if (selecionado) return f.vgtSelected
        return !f.vgtSelected
      })
    },
    getPorBusca(busca) {
      this.valueAttr = [...this.docsBackupFiltro]
      return this.valueAttr.filter(f => f.descricao.toLowerCase().includes(busca.toLowerCase()))
    },
  },
}
</script>
